import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sortBy: "",
};

export const sortSlice = createSlice({
  name: "sort",
  initialState,
  reducers: {
    changeSortBy: (state, action) => {
      state.sortBy = action.payload;
    },
  },
});

export const { changeSortBy } = sortSlice.actions;
export default sortSlice.reducer;
